import { render } from "./FirstLogin.vue?vue&type=template&id=8d765846&scoped=true"
import script from "./FirstLogin.vue?vue&type=script&lang=js"
export * from "./FirstLogin.vue?vue&type=script&lang=js"

import "./FirstLogin.vue?vue&type=style&index=0&id=8d765846&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d765846"]])

export default __exports__